import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { IncaRowContext } from '../IncaRowContext';
const EMPTY_ARRAY = [];
export const ScopedData = (props)=>{
    const { children } = props;
    const data = useSelector((state)=>state.data);
    return /*#__PURE__*/ _jsx(IncaRowContext, {
        path: EMPTY_ARRAY,
        children: (opts)=>children({
                dataActions: opts.dataActions,
                row: data.present,
                future: data.future,
                history: data.past
            })
    });
};
